<template>
  <div class="m-10">
    <div class="flex justify-center my-4">
      <div class="text-md text-center w-full">
        {{ title }}
      </div>
      <!-- <div class="rounded-sm flex w-1/3">
        <v-icon>mdi-magnify</v-icon>
        <div class="border border-gray-400 w-full px-2 rounded-md">
          <select v-model="search" class="w-full px-2">
            <option value="item" v-for="(item, i) in faq_titles" :key="i">
              {{ item.faq_title }}
            </option>
          </select>
        </div>
      </div> -->
    </div>
    <v-expansion-panels multiple>
      <v-expansion-panel v-for="(item, i) in faq_titles" :key="i">
        <v-expansion-panel-header @click="getSubMenuTitles(item.id)">
          <!-- {{ faq_titles }} -->
          {{ item.faq_title }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <!-- accordion2  -->
          <v-expansion-panel v-for="(item, j) in subMenuTitles" :key="i + j">
            <v-expansion-panel-header @click="getAnswers(item.q_id)">
              {{ item.question }}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <!-- answer  -->
              <v-expansion-panel-content>
                <div v-html="answer.answer"></div>
              </v-expansion-panel-content>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      search: "",
      faq_titles: [],
      subMenuTitles: [],
      title: "FREQUENTLY ASKED QUESTIONS",
      answer: {},
    };
  },
  mounted() {
    this.getMenuTitles();
  },
  methods: {
    selectTitle(item) {
      this.getSubMenuTitles(item);
    },
    getMenuTitles() {
      axios.get("/menu/faq_title").then((res) => {
        this.faq_titles = res.data;
      });
    },
    getSubMenuTitles(item) {
      let data = {
        faq_title_id: item,
      };
      axios.post("/faq/faq_questions", data).then((res) => {
        this.subMenuTitles = res.data;
      });
    },
    getAnswers(q_id) {
      let data = {
        q_id: q_id,
      };
      axios.post("/faq/faq_answers", data).then((res) => {
        this.answer = res.data;
      });
    },
  },
};
</script>